
export class User {
    active: boolean;
    contact: any;
    createdBy: string;
    createdDate: string;
    email: string;
    enabled: false
    firstName: string;
    gpsEnabled: false
    lastName: string;
    password: string;
    role: any;
    showInvoices: any;
    tenant: any;
    updatedBy: string;
    updatedDate: string;
    userId: string;
    webEnabled: boolean;
}